import serviceInstitucion from '@/services/GsEncuesta/institucion'

export default {
  INSTITUCION_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceInstitucion.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  INSTITUCION_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceInstitucion.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  INSTITUCION_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceInstitucion.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  INSTITUCION_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceInstitucion.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
